import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdditionalInfo {
  bulletIcon: string;
  description: string;
  visible: boolean;
}

interface Video {
  _id: string;
  title: string;
  description: string;
  duration: string;
  videoId: string;
  thumbnailUrl: string;
  isPublic: boolean;
  viewsCount: number;
  likesCount: number;
  dislikesCount: number;
  hideLikes: boolean;
  hideDislikes: boolean;
  additionalInfo: AdditionalInfo;
  commentStatus: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  lastModifiedBy: string;
  amplifyViews: number;
  createdBy: string;
  status: string;
  amplifyLikes: number;
  isLiked: boolean;
  isDisliked: boolean;
  isFavourite: boolean;
  isWatched?: boolean;
}

interface VideoState {
  video: Video | null;
}

const initialState: VideoState = {
  video: null,
};

const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    setVideo: (state, action: PayloadAction<Video>) => {
      state.video = action.payload;
    },

    
    toggleLike: (state) => {
      if (!state.video) return;
      if (state.video.isLiked) {
        state.video.isLiked = false;
        state.video.likesCount = Math.max(0, state.video.likesCount - 1);
      } else {
        state.video.isLiked = true;
        state.video.likesCount += 1;

        if (state.video.isDisliked) {
          state.video.isDisliked = false;
          state.video.dislikesCount = Math.max(0, state.video.dislikesCount - 1);
        }
      }
    },

    toggleDislike: (state) => {
      if (!state.video) return;
      if (state.video.isDisliked) {
        state.video.isDisliked = false;
        state.video.dislikesCount = Math.max(0, state.video.dislikesCount - 1);
      } else {
        state.video.isDisliked = true;
        state.video.dislikesCount += 1;

        if (state.video.isLiked) {
          state.video.isLiked = false;
          state.video.likesCount = Math.max(0, state.video.likesCount - 1);
        }
      }
    },

    setVideoWatchedFlag: (state, action: PayloadAction<boolean>) => {
      if (!state.video) return;
      state.video.isWatched = action.payload;
    }
  },
});

export const {
  setVideo,
  toggleLike,
  toggleDislike,
  setVideoWatchedFlag,
} = videoSlice.actions;

export default videoSlice.reducer;
